"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyStyles = void 0;
const copyStyles = (from, to, which) => {
    const styles = window.getComputedStyle(from);
    if (!styles)
        return;
    for (const property of which)
        to.style[property] = styles[property];
};
exports.copyStyles = copyStyles;
//# sourceMappingURL=util.js.map